import favoriteComponentsSelector from './favoriteComponents';

/**
 * returns true if given id is in the list of favorites else false
 * @param {object} state - redux state
 * @param {string} id - id of the component to look for
 * @returns {boolean} true if given id is in the list of favorites else false
 */
export default (state, id) => favoriteComponentsSelector(state).some(c => c.Id === id);
